import axios from 'axios'		//引入axios
import { Toast } from 'vant'	//引入Toast
import router from '../router'
import store from "../store";
let baseUrl = ''
if (process.env.VUE_APP_MODE === 'development') {
  // 开发环境下的执行操作
  baseUrl = process.env.VUE_APP_API_URL
} else {
  // 生产环境下的执行操作
  baseUrl = process.env.VUE_APP_API_URL
}

function upLoaderImg (file) {	//file为 你读取成功的回调文件信息
                               //new 一个FormData格式的参数
  let params = new FormData()
  // params.append('file', file.file)
  if (file.hasOwnProperty('module')){ // Vue 判断对象是否存在某个属性/字段
    params.append('file', file.file)
    params.append('module', file.module)
  } else {
    params.append('file', file.file)
  }
  // console.log(params)
  let config = {
    headers: { //添加请求头
      'Content-Type': 'multipart/form-data',
      Authorization: localStorage.getItem('token')
    }
  }
  return new Promise((resolve, reject) => {
    //把 uploadUrl 换成自己的 上传路径
    axios.post(baseUrl+'/api/filesystem/upload', params, config).then(res => {
      if (res.data.code == 200) {				//如果为真 resolve出去
        resolve(res.data)
      } else if(res.data.code==401){ // 登录过期

        Toast(res.data.message)
        store.commit("setToken", ''); // 清除key
        store.commit('setUserInfo', '')
        //跳转回login路由，并把目标路由的url路径保存在login的query中
        store.commit('setCurrPageUrl', router.currentRoute.fullPath)
        router.replace({
          name: 'Home',
          query: {redirect: router.currentRoute.fullPath}
        })

      } else {
        //否则 Toast 提示
        Toast.fail(res.data.message)
        reject(res.data)
      }
    }).catch(err => {
      Toast.fail('系统异常')
      reject(err)
    });
  })
}
export default upLoaderImg
